import {
    CREATE_SCHEDULE_BOOKING_START,
    CREATE_SCHEDULE_BOOKING_SUCCESS,
    CREATE_SCHEDULE_BOOKING_ERROR
} from '../../constants';
import showToaster from '../../helpers/toastrMessgaes/showToaster';
import { createScheduleBooking as mutation } from '../../lib/graphql/booking';
import history from '../../history';
import { setLoaderStart, setLoaderComplete } from '../loader/loader';
import { closeHeaderModal } from '../siteadmin/modalActions';

export const createScheduleBooking = (variables) => {

    return async (dispatch, getState, { client }) => {
        try {
            dispatch(setLoaderStart('scheduleLoading'));
            dispatch({ type: CREATE_SCHEDULE_BOOKING_START });

            const { data } = await client.mutate({
                mutation,
                variables: {
                    orderId: variables?.orderId,
                    dropOffLocation: variables?.dropOffLocation,
                    dropOffLat: variables?.dropOffLat,
                    dropOffLng: variables?.dropOffLng,
                    requestCurrency: variables?.requestCurrency,
                    promoId: variables?.promoId ? Number(variables?.promoId) : null,
                    reviewDescription: variables?.reviewDescription,
                    paymentType: Number(variables?.paymentType),
                    scheduleFrom: variables?.scheduleFrom
                }
            });

            dispatch(setLoaderComplete('scheduleLoading'));

            if (data?.createScheduleBooking?.status == 200) {
                dispatch({
                    type: CREATE_SCHEDULE_BOOKING_SUCCESS,
                });
                history.push('/bookings/upcoming');
                dispatch(closeHeaderModal('scheduleBookingForm'));
            } else {
                dispatch({
                    type: CREATE_SCHEDULE_BOOKING_ERROR,
                    payload: {
                        error: data?.createScheduleBooking?.errorMessage,
                    },
                });
                await showToaster({ messageId: 'errorMessage', toasterType: 'error', requestContent:  data?.createScheduleBooking?.errorMessage })
            }
        } catch (error) {
            await showToaster({ messageId: 'errorMessage', toasterType: 'error', requestContent:  error  })
            dispatch({ type: CREATE_SCHEDULE_BOOKING_ERROR });
            dispatch(setLoaderComplete('scheduleLoading'));
        }
    }
}
